export default __webpack_public_path__ + "static/media/adhyanshala-01.614cfa55.png";